/**
 * Adzuki.Typeahead
 */

(function Typeahead($, Adzuki)
{
	"use strict";

	var delay      = 1000; // ms
	var max_items  = 250;
	var min_length = 2; // min num characters before firing

	var typeahead = function Typeahead(
		el,
		azSource,
		azAfterSelect,
		azTemplate,
		azMatcher,
		azSorter,
		azReplace,
		azMinLength
	)
	{
		var self = this,
		    ta_opts,
		    _request              = null,
		    _search_history_cache = null,
			_replace              = false;

		try
		{
			// enforce 'new' operator to ensure 'this' points to this
			// instance, instead of the global window object.
			// in other Adzuki modules, this is enforced via a thrown Error,
			// but Adzuki.Typeahead is not generally assigned to a variable
			// like other Adzuki modules and it wouldn't make sense to throw
			// an Error because no methods are called on it directly,
			// so just return a new instance of this on runtime
			if ((this instanceof Typeahead) === false) {
				return new Typeahead(el, azSource, azAfterSelect, azTemplate, azMatcher, azSorter, azReplace, azMinLength);
			}

			// need a source - be it a custom function or a url - that returns json
			if (azSource === undefined) {
				throw new Error('undefined source!');
			}

			this.$el           = null;
			this.$hidden_input = null;
			this.$reset        = null;

			// reference to the typeahead input element
			if (el instanceof jQuery) {
				this.$el = el;
			} else {
				this.$el = $(el);
			}

			if (!this.$el.length) {
				throw new Error('cannot find ' + el);
			}

			// find hidden input
			if (this.$el.data('hidden-id'))
			{
				this.$hidden_input = $('#'+this.$el.data('hidden-id'));

				// find reset field in parent element, if present
				this.$reset = this._initResetButton();
			}

			if (typeof azReplace === 'boolean') {
				_replace = azReplace;
			}

			if (typeof azMinLength === 'number') {
				min_length = azMinLength;
			}

			// bubble all the way up to document, to handle ajax-appended typeaheads
			// $(document).on('focus', el, function instantiateTypeahead()
			this.$el.on('focus', function instantiateTypeahead()
			{
				var $self = $(this),
				    url;

				// if typeahead already exists
				if ($self.data('typeahead') !== undefined)
				{
					if (_replace) {
						$self.off('keyup');
						$self.off('paste');
						$self.removeData('typeahead');
					} else {
						// trigger keyup event on focus to bring up
						// global search history results when there
						// is no term present
						if ($self.val().length === 0) {
							// todo: do this on first click after initial instantiation
							$self.trigger('keyup');
						}

						// don't instantiate it twice
						return;
					}
				}

				ta_opts = {
					minLength: 0,
					delay    : delay,
					items    : max_items,
					source   : function dataSource(term, display)
					{
						if ($self.hasClass('global-search') && term.length === 0 && !$self.hasClass('ignore-history')) {
							if (_search_history_cache === null) {
								Adzuki.Ajax.get('/Searches/getGlobalSearchHistory')
								.then(function getGlobalSearchHistory(history) {
									_search_history_cache = history;
									display(_search_history_cache);
								});
							}
							else {
								display(_search_history_cache);
							}

							return;
						}
						else if (term.length < min_length) {
							return;
						}

						// show the ajax loading spinner no matter what.
						// custom sources are responsible for hiding it appropriately
						$self.addClass('ajax-spinner');

						if (typeof azSource === 'function')
						{
							azSource(term, display, $self);
						}
						else
						{
							// ensure a trailing forward slash for 'term' argument to follow
							url = Adzuki.get_url(azSource);

							// eslint-disable-next-line no-magic-numbers
							if (url.charAt(url.length - 1) !== '/') {
								url = url + '/';
							}

							// append search term
							url = url + encodeURIComponent(term);

							// search
							_request = Adzuki.Ajax.get(url);
							_request.then(function fetch(response)
							{
								// remove items is non-string names to keep typeahead from dying a horrible death
								$.each(response, function iterator(i, item) {
									if (typeof item.name !== 'string') {
										console.warn('Adzuki.Typeahead - each JSON element must include a "name" key with a string value. Otherwise the element will be deleted from the response');
										delete response[i];
									}
								});

								$self.removeClass('ajax-spinner');

								if ($self.val().length >= min_length) {
									display(response);
									_request = null;
								}
							});
						}
					},
					afterSelect: function select(item)
					{
						if (item.header) {
							$self.val('');
							return;
						}

						if (typeof azAfterSelect === 'function') {
							// item  = selected item
							// $self = reference to typeahead search input
							// self  = reference to this instance of Adzuki.Typeahead
							azAfterSelect(item, $self, self);
							$self.trigger('adz.typeahead.afterSelect', item);
						}

						return;
					},
					template: function template(item) {
						var html    = '',
						    classes = ['dropdown-item'],
						    data    = (typeof azTemplate === 'function')
						            ? azTemplate(item)
						            : item.name;

						if (item.header) {
							classes.push('header');
						}

						html = '<a class="' + classes.join(' ') + '">?</a>';
						return html.replace('?', data);
					},
					highlighter: function highlighter(item)
					{
						var $_tmp;
						var query_re = new RegExp('('+escapeRegex(this.query)+')', "gi");
						var textNodes;
						var item_obj;

						try
						{
							// if item is a valid JSON node, parse it for icons!
							item_obj = JSON.parse(item);

							if (item_obj.extra && item_obj.show_extra === true) {
								$_tmp =  $('<div><i class="'+item_obj.icon+'" style="'+item_obj.icon_style+'"></i> '+item_obj.name+' <br>&nbsp;&nbsp;&nbsp;&nbsp;<small>' + item_obj.extra + '</small></div>');
							} else {
								$_tmp = $('<div><i class="'+item_obj.icon+'" style="'+item_obj.icon_style+'"></i> '+item_obj.name+'</div>');
							}
						}
						catch (err) {
							// if item is not a valid JSON node, treat it as a string
							$_tmp = $('<div></div>').html(item);
						}

						// get a dom node with just the text
						textNodes = $_tmp.contents().filter(function filterQueryText() {
							return this.nodeType === 3;
						});

						// replace the text with a re-matched bolded version
						textNodes.replaceWith(function highlightQuery() {
							return $(this).text().replace(query_re, '<b>$1</b>');
						});

						return $_tmp.html();
					},
					matcher: function matcher(item) {
						if (typeof azMatcher === 'function') {
							return azMatcher(item);
						}

						// essentially disables the matcher,
						// so we can show error messages in the
						// dropdown like "no results found"
						return true;
					},
				};

				if (typeof azSorter === 'function') {
					ta_opts.sorter = azSorter;
				}

				$self.addClass('adzuki-typeahead');
				$self.typeahead(ta_opts);

				// show recent search history on first-time init
				$self.trigger('keyup');
			});

			this.$el.on('keyup', function charDetect() {
				if ($(this).val().length < min_length && _request) {
					_request.abort();
					$(this).removeClass('ajax-spinner');
				}
			});

			// support mouse-pasting
			this.$el.on('paste', function mousePaste() {
				var $self = $(this);
				setTimeout(function _mousePaste() {
					$self.trigger('keyup');
				}, 0);
			});

			// data API
			this.$el.data('adzuki', {
				setHiddenValue: function _api_setHiddenValue(val) {
					self.setHiddenValue(val);
				},
				reset: function _api_reset() {
					self.reset();
				}
			});

			// return API
			return this;
		}
		catch (err)
		{
			console.log('[Adzuki.Typeahead]', err);
		}
	};


	// finds and sets up reset link click binding
	typeahead.prototype._initResetButton = function _initResetButton()
	{
		var $parent = this.$el.parent(),
		    $reset;

		if ($parent.hasClass('input-group')) {
			$parent = $parent.parent();
		}

		$reset = $parent.find('.reset-typeahead');

		if ($reset.length)
		{
			// save the reference
			this.$reset = $reset;

			$reset.click((e) => {
				e.preventDefault();
				this.reset();
			});
		}
		else {
			return false;
		}

		return $reset;
	};

	// if hidden field exists, use this to set the value of it.
	// also, freeze the state of the typeahead and show the reset link
	typeahead.prototype.setHiddenValue = function setHiddenValue(val)
	{
		if (this.$hidden_input)
		{
			this.$hidden_input.val(val);

			if (this.$reset) {
				this.$el.prop('disabled', true);
				this.$reset.removeClass('hidden');
			}

			this.$el.trigger('ta.set-hidden', val);
		}
	};

	// reset state of typeahead (clear text/hidden inputs, re-enable text)
	typeahead.prototype.reset = function reset()
	{
		if (this.$hidden_input)
		{
			let previousValue = this.$hidden_input.val();
			this.$hidden_input.val('');

			if (this.$reset) {
				this.$el.prop('disabled', false).val('').focus();
				this.$reset.addClass('hidden');
			}

			this.$el.trigger('ta.reset', previousValue);
		}
	};

	function escapeRegex(val)
	{
		return val.replace(/\\/g, '\\\\')
		       .replace(/\^/g, '\\\^')
		       .replace(/\$/g, '\\\$')
		       .replace(/\./g, '\\\.')
		       .replace(/\|/g, '\\\|')
		       .replace(/\?/g, '\\\?')
		       .replace(/\*/g, '\\\*')
		       .replace(/\+/g, '\\\+')
		       .replace(/\(/g, '\\\(')
		       .replace(/\)/g, '\\\)')
		       .replace(/\[/g, '\\\[')
		       .replace(/\]/g, '\\\]')
		       .replace(/\{/g, '\\\{')
		       .replace(/\}/g, '\\\}');
	}

	Adzuki.Typeahead = typeahead;
}(jQuery, window.Adzuki || {}));
